import { h } from 'preact'; /** @jsx h */
import './loadmore.scss';

const LoadMore = ({ shownProductsCount, totalProductsCount, handler, buttonText }) => {
    return (
        <div className="ws-products-load-more">
            {shownProductsCount < totalProductsCount && (
                <button className="ws-load-more-button" onClick={handler}>
                    {buttonText}
                </button>
            )}
        </div>
    );
};

export default LoadMore;
